import { render } from "./UnidadmedidaList.vue?vue&type=template&id=77c15730&scoped=true"
import script from "./UnidadmedidaList.vue?vue&type=script&lang=js"
export * from "./UnidadmedidaList.vue?vue&type=script&lang=js"

import "./UnidadmedidaList.vue?vue&type=style&index=0&id=77c15730&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c15730"]])

export default __exports__